import { typeDetails } from "src/app/shared/models/models";
export class lightLogo{
  url:string = '';
}
export class darkLogo{
  url:string = '';
}
export class mainLogo{
  url:string = '';
}
export class flatData{
  mainLogo:mainLogo = new mainLogo
  darkLogo:darkLogo = new darkLogo
  lightLogo:lightLogo = new lightLogo
}
export class  type{
  url:string = '';
  flatData:  flatData = new   flatData;
}
export class  ourSocialMedia{
  name:string = '';
  value:string = '';
  type: type = new  type();
}
export class ourContacts{
  name:string = '';
  value:string = '';
  isURL:string = '';
  type:typeDetails = new typeDetails();
}
export class ContactUsDetails {
  pageTitle:string = '';
  ourContacts:ourContacts = new ourContacts();
  ourLocation:string = '';
  ourSocialMedia:ourSocialMedia = new ourSocialMedia();
}

export class ContactUsModel {
  flatData: ContactUsDetails = new ContactUsDetails();
}